import React, { useState, useEffect } from "react";
import buildingImg from "../../assets/images/building_burz.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
// import { DaySelector } from "./day-selector";
import { toast, Bounce } from "react-toastify";
import { DaySelector } from "../edu-helper/day-selector";

export default function JobScheduleCampusEdit({
  selectJobScheduleCampusRow,
  setSelectJobScheduleCampusRow,
  setForceUpdate,
  forceUpdate,
  activateJobScheduleCampusEdit,
  setActivateJobScheduleCampusEdit,
}) {
  let navigate = useNavigate();
  let loginUser = {};
  try {
    loginUser = JSON.parse(localStorage.getItem("user"));
  } catch (error) {
    console.error("Error parsing user data from localStorage:", error);
  }
  const { campus_description, campus_name, company, days, id } =
    selectJobScheduleCampusRow;

  const [selectedDays, setSelectedDays] = useState([]);

  useEffect(() => {
    setSelectedDays(days);
  }, [activateJobScheduleCampusEdit]);

  const areArraysEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item, index) => item === arr2[index]);
  };

  const getChangedFields = () => {
    return {
      ...(areArraysEqual(days, selectedDays) ? {} : { days: selectedDays }),
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const patchData = getChangedFields();
    let response;
    try {
      response = await axios(`${baseUrl}/campus_update/${id}/`, {
        method: "PUT",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: { ...patchData },
      });
      if (response?.status === 200) {
        let unique = document.getElementById("close8");
        unique.click();
        setSelectJobScheduleCampusRow({});
        setActivateJobScheduleCampusEdit(false);
        setForceUpdate(!forceUpdate);
        toast.success("Edit JobSchedule Successfully", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <>
      <div
        className="modal fade custom-modal addjobschedule-modal"
        id="editjobschedulecampus"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title" id="">
                Edit Campus JobSchedule
              </h5>
              <button
                type="button"
                className="modal-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="close8"
                onClick={() => {
                  setSelectJobScheduleCampusRow({});
                  setActivateJobScheduleCampusEdit(false);
                }}
              >
                <i className="fa fa-times" />
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex flex-row justify-content-center align-items-center">
                <div className="col-lg-5 text-center">
                  <div className="addbus-modal-innr">
                    <img
                      src={buildingImg}
                      width="336"
                      height="336"
                      alt="edit-jobschedule"
                    />
                    <form action="" onSubmit={handleSubmit}>
                      <div className="row justify-content-center">
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            name="jobschedule_companyname"
                            disabled={true}
                            value={company?.name || ""}
                          />
                          <span className="fa fa-building icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            name="jobschedule_campusname"
                            disabled={true}
                            value={campus_name || ""}
                          />
                          <span className="fa fa-building icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          <input
                            type="text"
                            className="form-control"
                            name="jobschedule_campusdesc"
                            disabled={true}
                            value={campus_description || ""}
                          />
                          <span className="fa fa-building icon" />
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3 text-start">
                          {activateJobScheduleCampusEdit && Boolean(days) ? (
                            <DaySelector
                              initialSelectedDays={days}
                              onDaysChange={setSelectedDays}
                            />
                          ) : (
                            <> </>
                          )}
                        </div>
                        <div className="frm-bx mb-4 col-lg-8 mb-3">
                          <button className="thm-btn" type="submit">
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
